@if (!isMobile) {
  <avs-switch-pdu-children-table
    [deviceId]="parentId()"
    [isNetworkSwitch]="isNetworkSwitch()"
    [locationId]="locationId()"
    [predefinedChild]="port().orderNumber"
    [title]="isNetworkSwitch() ? 'Port: ' : 'Outlet: '+port().orderNumber"
  />
}

@if (isNetworkSwitch()) {
  <mat-card class="card pb-6 mt-4">
    <mat-card-title class="pb-4">Port Details</mat-card-title>
    <mat-card-content class="p-0 port-details-container">
      <ul
        class="grid grid-cols-2 gap-5"
        [class.grid-cols-1]="!isMobile"
      >
        @for (attribute of realtimeAttributes(); track attribute.name) {
          <li class="flex justify-between text-sm">
            <div class="w-[220px] whitespace-nowrap overflow-ellipsis overflow-hidden attr-friendly-name font-semibold">
              {{ attribute.friendlyName }}:
            </div>
            <div class="flex-grow pl-2 attr-friendly-value">
              {{ attribute.value || 0 }}
              @if (attribute.measurementUnit | avsMeasurementUnitDisplay; as unit) {
                <span class="port-details-units">&nbsp;{{ unit }}</span>
              }
            </div>
          </li>
        }
      </ul>
    </mat-card-content>
  </mat-card>
}

<avs-device-stats-chart
  [device]="port().childDevice"
  [friendlyNameEditDisabled]="true"
  [locationId]="locationId()"
/>

@if ('data-attributes' | avsFeatureFlag) {
  <avs-device-attributes
    class="mb-4 block"
    [device]="port().childDevice"
    [title]="isNetworkSwitch() ? 'Port Attributes' : 'Outlet Attributes'"
  />
}

@if (isNetworkSwitch()) {
  <mat-card class="card pb-6 mt-4">
    <mat-card-title class="pb-4">Incidents</mat-card-title>
    <mat-card-content class="p-0 port-details-container">
      <avs-incidents-table-desktop-filters
        [dropdownFilters]="false"
        [filtersEnabled]="true"
        [resolvedIncidentsLoading]="resolvedIncidentsLoading"
        tableId="device-details-incidents-table"
      />
      <app-incidents-table
        [isInjected]="true"
        noDataText="The device is working properly"
      />
    </mat-card-content>
  </mat-card>
}
